<template>
  <form>

    <div class="row pt-3">
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 mb-4">
                <div class="avatar-upload">
                  <div class="avatar-edit">
                    <input 
                      type='file' 
                      id="imageUpload"
                      @change="onAvatarChange"
                      accept=".png, .jpg, .jpeg"
                    />
                    <label for="imageUpload"><i class="uil uil-pen"></i>  </label>
                  </div>
                  <div class="avatar-preview">
                    <img
                      ref="imagePreview"
                      alt
                      class="avatar-md rounded-rounded"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <TextField 
                  :placeholder="$t('company.form.name.placeholder')"
                  :label="$t('company.form.name.label')"
                  v-model="model.name"
                  :error="$v.model.name.$error"
                  :errorMessage="$v.model.name.errorMessage"
                />
                <TextField 
                  :placeholder="$t('company.form.website.placeholder')"
                  :label="$t('company.form.website.label')"
                  v-model="model.website"
                />
                <TextField 
                  :placeholder="$t('company.form.contact_no.placeholder')"
                  :label="$t('company.form.contact_no.label')"
                  v-model="model.contact_no"
                  :error="$v.model.contact_no.$error"
                  :errorMessage="$v.model.contact_no.errorMessage"
                />
                <TextField 
                  :placeholder="$t('company.form.email.placeholder')"
                  :label="$t('company.form.email.label')"
                  v-model="model.email"
                  :error="$v.model.email.$error"
                  :errorMessage="$v.model.email.errorMessage"
                />
                <TextField
                  :placeholder="$t('company.form.ats_id.placeholder')"
                  :label="$t('company.form.ats_id.label')"
                  v-model="model.ats_id"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('company.form.information')}}</h4>
            <p class="sub-header"></p>
            <div class="row">
              <div class=" col-md-6">
                <div class="form-group">
                  <Select
                    autoload
                    textField="value"
                    name="timezone"
                    placeholder="Select Timezone"
                    label="Timezone"
                    v-model="model.timezone_id"
                    moduleName="timezone"
                    endpoint="all"
                    trackBy="_id"
                    isData
                    :error="$v.model.timezone_id.$error"
                    :errorMessage="$v.model.timezone_id.errorMessage"
                    @input="selectedTimezone"
                  />
                </div>
              </div>
              <div class=" col-md-6">
                <div class="form-group">
                  <Multiselect
                    autoload
                    searchable
                    :multiple="false"
                    moduleName="industry"
                    endpoint="all"
                    v-model="model.industry_id"
                    :placeholder="$t('user.form.industry.placeholder')"
                    :textLabel="$t('user.form.industry.label')"
                    trackBy="_id"
                    label="name"
                    :error="$v.model.industry_id.$error"
                    :errorMessage="$v.model.industry_id.errorMessage"
                  />
                </div>
              </div>
              <!-- <div class=" col-md-6">
                <div class="form-group">
                  <Multiselect
                    autoload
                    searchable
                    multiple
                    v-model="model.source_company"
                    moduleName="industry"
                    endpoint="getSourceCompany"
                    placeholder="Enter Source Company"
                    textLabel="Source Companies"
                    trackBy="_id"
                    label="name"
                  />
                </div>
              </div> -->
              <div class=" col-md-6">
                <div class="form-group">
                  <Select
                    autoload
                    placeholder="Select Brand"
                    label="Brands"
                    name="brand"
                    v-model="model.brand_id"
                    moduleName="brand"
                    endpoint="all"
                    @input="selectedBrand"
                    :error="$v.model.brand_id.$error"
                    :errorMessage="$v.model.brand_id.errorMessage"
                  />
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-6">
                <Select
                  autoload
                  placeholder="Language of Communication"
                  label="Language of Communication"
                  v-model="model.language"
                  moduleName="languages"
                  textField="text"
                  valueField="value"
                  hasNoDefault
                  :error="$v.model.language.$error"
                  :errorMessage="$v.model.language.errorMessage"
                />
              </div>
              <div class="col-md-6">
                <TextField 
                  placeholder="No of Employees"
                  label="No of Employees"
                  v-model="model.number_of_employees"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <TextField 
                  :placeholder="$t('company.form.city.placeholder')"
                  :label="$t('company.form.city.label')"
                  v-model="model.city"
                  :error="$v.model.city.$error"
                  :errorMessage="$v.model.city.errorMessage"
                />
              </div>
              <div class="col-md-6">
                <TextField 
                  :placeholder="$t('company.form.country.placeholder')"
                  :label="$t('company.form.country.label')"
                  v-model="model.country"
                  :error="$v.model.country.$error"
                  :errorMessage="$v.model.country.errorMessage"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <TextField
                  placeholder="Complete Address"
                  label="Complete Address"
                  v-model="model.complete_address"
                  :error="$v.model.complete_address.$error"
                  :errorMessage="$v.model.complete_address.errorMessage"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 textOnInput">
                <vue-editor style="max-height: 285px; overflow-y: scroll;"
                  :placeholder="$t('company.form.remarks.placeholder')"
                  v-model="model.remarks">
                </vue-editor>
              </div>
            </div>
            <hr>
            
            <div class="row mt-2">
              <div class="col-6">
                <h4 class="header-title mt-0 mb-3">{{$t('company.form.commission_setup')}}</h4>
                <div class="form-group">
                  <b-form-checkbox 
                    v-model="model.fixed" 
                    name="check-button" 
                    switch
                    @change="onBlur"
                  >
                    {{$t('company.form.use_fixed_rate')}}
                  </b-form-checkbox>
                </div>
                <div class="row">
                  <TextField 
                    :max="model.fixed ? 0 : 100"
                    :placeholder="model.fixed ? 'xx,xxx' : '%'"
                    :label="$t('company.form.commission_rate.label')"
                    type="number"
                    class="col-12"
                    v-model="model.rate"
                  />
                </div>
              </div>
              <div class="col-6">
                <h4 class="header-title mt-0 mb-3">Hiring Setup</h4>
                <div class="form-group">
                  <b-form-checkbox 
                    v-model="model.is_non_japanese_hiring" 
                    name="check-button" 
                    switch
                    @change="onBlur"
                  >
                    Hire non-Japanese
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </form>
</template>

<script>
// import Dropdown from '@components/form/dropdown.vue'
// import Multiselect from 'vue-multiselect'
import TextField from '@components/form2/textfield.vue'
import Multiselect from '@components/form2/select/multiselect'
import FormMixins from '@mixins/form'
import timezone from '@src/data/timezone.json'
import Select from '@components/form2/select'

import { VueEditor } from 'vue2-editor'
import { required, email } from 'vuelidate/lib/validators'

export default {
  components: {
    TextField,
    Multiselect,
    VueEditor,
    Select
  },
  mixins: [ FormMixins ],
  data () {
    return {
      model:{
        name: '',
        remarks: '',
        fixed:false,
        website: '',
        contact_no: '',
        email: '',
        avatar_path: '',
        city: '',
        country: 'Japan',
        rate:0,
        timezone_id:Object,
        brand_id: '',
        ats_id: '',
        language: '',
      },
      fullWidth: document.getElementsByClassName('content-page').item(0).clientWidth,
      timezone_option: timezone,
      industry_options: [],
      function_options: [],
      source_company_options: [],
      brand_options: []
    }
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    rowId() {
      let parameters = this.parameters || {}
      return parameters.rowId
    },
    submitted () {
      let parameters = this.parameters || {}
      return parameters.submitted
    }
  },
  validations: {
    model:{
      name: { required },
      email: { required, email },
      timezone_id: { required },
      brand_id: { required },
      contact_no: { required },
      complete_address: { required },
      city: { required },
      country: { required },
      language: { required },
      industry_id: { required },
    }
  },
  methods: {
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    selectedBrand(val){
      this.model.brand_id = val || ''
    },
    selectedTimezone(val){
      this.model.timezone_id = val || ''
    },
    onBlur(){
      if(parseInt(this.model.rate) > 100){
        this.model.rate = 100
      }
    },
    onAvatarChange(e) {
      if (e && e.target && e.target.files && e.target.files.length) {
        this.model.avatar_path = e.target.files[0]
        this.$refs.imagePreview.src = URL.createObjectURL(e.target.files[0])
      }
    },
    findUser() {
      let id = this.rowId

      return this.$store.dispatch('company/find', { id })
      .then(result => {
        if (result && result.data) {
          let { data } = result || {}

          if (data && data.rate && typeof data.rate == 'object') {
            data.rate = parseFloat(data.rate.$numberDecimal)
          }
          
          if(data && data.language) {
            let { language } = data
            data.language = {
              value: language,
              text: language == 'jp' ? 'Japanese' : language == 'us' ? 'English (US)' : 'All'
            }
          }
          // if(!data.timezone_id){
          //   data.timezone_id = this.getDefaultTimzone()
          // }
          this.model = { ...result.data }


          this.renderAvatar()
        }
      })
      .catch(err => console.log(err))
    },
    renderAvatar () {
      if (this.$refs.imagePreview) {
        if (this.model && Object.entries(this.model).length && this.model.avatar_path) {
          this.$refs.imagePreview.src = this.model.avatar_path
        }
        else this.$refs.imagePreview.src = require('@assets/images/users/avatar-7.jpg')
      }
    },
    getDefaultTimzone(){
      return this.$store.dispatch('timezone/all', {filter: 'Japan Standard Time'})
      .then(res => {
        let { data } = res
        if(data.length) {
          this.model.timezone_id = data[0]._id
          // return data[0]
        }
      })
    }
  },
  mounted(){
    window.addEventListener('resize', this.handleResize)

    if (this.rowId) {
      this.findUser()
    }
  },
  watch: {
    rowId: function () {
      if (this.rowId) {
        this.findUser()
      }
    },
    submitted: function () {
      this.model = {
        name: '',
        remarks: '',
        fixed:false,
        website: '',
        contact_no: '',
        email: '',
        avatar_path: '',
        city: '',
        country: '',
        rate:0,
        timezone_id:Object,
        brand_id: '',
        ats_id: ''
      }
      this.findUser()
    }
  },
  updated(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>